export default __webpack_public_path__ + "static/media/onboarding-graphics-enterprise-employee.baa67037.png";